import { EventActions, GiftCardActions, SerialTicketActions } from '../actions'
import type { RootProps } from '../root'
import type { EventView, GiftCardView, SerialTicketView } from '../types'
import { getCheckout } from './checkout'
import { getGiftCardProps } from './gift-card'
import {
    getEventCompletedResponse,
    getGiftCardCompletedResponse,
    getPaymentPendingResponse,
    getSaleExpiredResponse,
    getSerialTicketCompletedResponse,
    getSessionExpiredResponse,
    getSoldOutResponse,
    getTemporarilyUnavailableResponse,
} from './response'
import { getSerialTicketProps } from './serial-ticket'

export const getEventRootProps = (view: EventView): RootProps => {
    const { state } = view
    const { isAddProductsFlow, isInitializing, sessionEndTime, status, isProductSaleEnabled } =
        state

    if (isInitializing) {
        return {
            isLoading: true,
        }
    }

    switch (status) {
        case 'checkout':
            if (!isAddProductsFlow && sessionEndTime < Date.now()) {
                return {
                    response: getSessionExpiredResponse(state),
                }
            }

            return {
                checkout: getCheckout(view),
            }

        case 'completed':
            return {
                response: getEventCompletedResponse(view),
            }

        case 'sold-out':
            if (isProductSaleEnabled && isAddProductsFlow) {
                return {
                    checkout: getCheckout(view),
                }
            }

            return {
                response: getSoldOutResponse(state),
            }

        case 'temporarily-unavailable':
            return {
                response: getTemporarilyUnavailableResponse(state),
            }

        case 'payment-pending':
            return {
                response: getPaymentPendingResponse(view, async () => EventActions.reset(view)),
            }

        case 'sale-expired':
            return {
                response: getSaleExpiredResponse(state),
            }

        default:
            return {
                response: { theme: state.theme, title: 'Error' },
            }
    }
}

export const getGiftCardRootProps = (view: GiftCardView): RootProps => {
    const { state } = view
    const { data } = state

    if (!data) {
        return {
            isLoading: true,
        }
    }

    switch (data.status) {
        case 'completed':
            return {
                response: getGiftCardCompletedResponse(view),
            }

        case 'payment-pending':
            return {
                response: getPaymentPendingResponse(view, async () => GiftCardActions.reset(view)),
            }

        default:
            return { giftCard: getGiftCardProps(view) }
    }
}

export const getSerialTicketRootProps = (view: SerialTicketView): RootProps => {
    const { state } = view
    const { data } = state

    if (!data) {
        return {
            isLoading: true,
        }
    }

    switch (data.status) {
        case 'completed':
            return {
                response: getSerialTicketCompletedResponse(view),
            }

        case 'payment-pending':
            return {
                response: getPaymentPendingResponse(view, async () =>
                    SerialTicketActions.reset(view),
                ),
            }

        default:
            return { serialTicket: getSerialTicketProps(view) }
    }
}
